import React from "react";
import Reports from "./Reports";

const LeadReport = () => <Reports reportType="lead" />;

export default LeadReport;
